import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { ConfigGuard } from '@occc-app/App/guards';
import { Can } from '@occc-app/App/PolicyBasedAccessControl/components/Can';
import { UpdateRetailerNetwork } from '@occc-app/App/PolicyBasedAccessControl/userActions';
import UnauthorizedPage from '@occc-app/routes/Unauthorized';

type RetailerNetworkUpdatePageGuardProps = {
  children: ReactNode;
};

export const RetailerNetworkUpdatePageGuard = ({
  children,
}: RetailerNetworkUpdatePageGuardProps) => {
  const { networkId = '' } = useParams<{ networkId: string }>();

  return (
    <ConfigGuard isFeatureEnabled={(config) => !!config.retailerConnect?.enabled}>
      <Can I={UpdateRetailerNetwork({ uuid: networkId })} fallback={<UnauthorizedPage />}>
        {children}
      </Can>
    </ConfigGuard>
  );
};
